import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import landingEN from "../data/en/landing.json";
import landingLT from "../data/lt/landing.json";
import recentsEN from "../data/en/recents.json";
import recentsLT from "../data/lt/recents.json";
import productsEN from "../data/en/products.json";
import productsLT from "../data/lt/products.json";
import servicesEN from "../data/en/services.json";
import servicesLT from "../data/lt/services.json";
import eshopEN from "../data/en/eshop.json";
import eshopLT from "../data/lt/eshop.json";
const savedLanguage = sessionStorage.getItem("language") || "lt";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        ...landingEN,
        ...recentsEN,
        ...productsEN,
        ...servicesEN,
        ...eshopEN,
      },
    },
    lt: {
      translation: {
        ...landingLT,
        ...recentsLT,
        ...productsLT,
        ...servicesLT,
        ...eshopLT,
      },
    },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
